/**
 * @desc 查询通知管理列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.InformManagementConditionsQuery,
): Promise<defs.StandardReturn<defs.Pager<defs.InformDTO>>> {
  return defHttp.post({
    url: '/web/notify/queryNotice',
    data,
  });
}

export function mock(
  data: defs.InformManagementConditionsQuery,
): Promise<defs.StandardReturn<defs.Pager<defs.InformDTO>>> {
  return defHttp.post({
    url: '/mock/web/notify/queryNotice',
    data,
  });
}
